<template>
  <List style="height: 100%;">
    <ListItemGroup :value="selectedIndex" color="indigo">
      <template v-for="(job, index) in jobs">
        <ListItem
            :key="index"
            :value="job.id"
            three-line
            class="pr-2"
            @click="onSelectJob"
        >
          <ListItemContent>
            <div class="d-flex align-center justify-space-between" style="gap: 8px">
              <div class="d-flex align-center" style="gap: 16px; width: 100%">
                <v-badge :content="1">
                  <div class="flex-shrink-0">
                    <v-badge overlap dot color="tertiary">
                      <template
                          v-slot:badge
                          v-if="job.unreadCount !== 0"
                      >
                        <Label :text="job.unreadCount" size="body-2" bold />
                      </template>

                      <v-avatar v-if="job.company.logoUrl" size="54">
                        <v-img :src="job.company.logoUrl" contain />
                      </v-avatar>
                      <v-avatar v-else size="54">
                        <v-img src="@/assets/no_image_white.png" contain />
                      </v-avatar>
                    </v-badge>
                  </div>
                </v-badge>

                <div class="d-flex flex-column flex-1" style="gap: 6px">
                  <div class="d-flex justify-space-between align-center">
                    <Label :text="job.company.name" no-of-lines="1" />
                    <Label :text="messagedAt(job.latestUtterance)" size="body-2" class="flex-shrink-0" style="color: #888" />
                  </div>
                  <Label :text="job.job.name" no-of-lines="1" />
                  <Label :text="detail(job.latestUtterance)" no-of-lines="1" style="color: #888; min-width: 0" />
                </div>
              </div>
            </div>
          </ListItemContent>
        </ListItem>

        <Divider :key="`divider-${index}`" />
      </template>
    </ListItemGroup>
  </List>
</template>

<script>
import List from "@/components/atoms/List";
import ListItemGroup from "@/components/atoms/ListItemGroup";
import ListItem from "@/components/atoms/ListItem";
import ListItemContent from "@/components/atoms/ListItemContent";
import ComponentMixin from "@/components/ComponentMixin";
import Divider from "@/components/atoms/Divider";
import Label from '../atoms/Label'

export default {
  mixins: [ComponentMixin],
  name: "MessageJobList",
  components: { Label, Divider, ListItemContent, ListItem, ListItemGroup, List},
  props: {
    jobs: {
      type: Array,
    },
    value: {
      type: String
    }
  },
  computed: {
    messagedAt() {
      return (utterance) => {
        if (utterance) {
          return this.toDaysAfter(utterance.createdAt) === 0 ? this.fromNow(utterance.createdAt) : this.dateToText(utterance.created_at);
        }
        return ""
      }
    },
    detail() {
      return (utterance) => {
        if (utterance) {
          return utterance.detail;
        }
        return ""
      }
    },
    selectedIndex() {
      return this.jobs.findIndex(job => job.id === this.value)
    }
  },
  methods: {
    onSelectJob(id) {
      this.$emit("selectJob", id)
    }
  }
}
</script>

<style scoped>

</style>